import styled from '@emotion/styled';

/** 미인증 유저에게 보여줄 자리값. blur 는 시각 효과일 뿐이라 실제 금액을 DOM 에 넣지 않는다 */
const MASKED_AMOUNT_PLACEHOLDER = '50,000';

/**
 * 금액 한 칸 (#2182 MG 섹션에서 공용화 — studio#2524 샛별 섹션과 공유).
 *
 * 금액이 가려졌는지는 스타일이 아니라 `data-masked` 로 드러낸다. blur 클래스는 표현일 뿐이라
 * 토큰이 바뀌면 의미가 사라지지만, 이 속성은 "이 유저에게 금액을 감췄다"는 사실 자체를 남긴다.
 */
export default function AmountValue({ amountFormat, isBlur }: { amountFormat?: string; isBlur: boolean }) {
  return (
    <SAmount className={isBlur ? 'bold blur' : 'bold'} data-masked={isBlur}>
      {isBlur ? MASKED_AMOUNT_PLACEHOLDER : (amountFormat ?? '-')}
    </SAmount>
  );
}

/**
 * 블러는 이 칸이 스스로 건다. 부모(SInformationItem)의 `.blur` 에 기대면 행 밖에 놓인 금액은
 * 자리값(50,000)이 블러 없이 실제 금액처럼 보인다 (studio#2524 하네스에서 발견).
 */
const SAmount = styled.span`
  &.blur {
    filter: blur(5px);
  }
`;
